import {HttpErrorResponse} from '@angular/common/http';
import {empty} from '@catcore/utils/string';
import {webapiErrorToLabel} from '@catloader/loader-service/config/webapi-response-errors';
import {ErrorMessage, NormalizedApiError} from '@catloader/loader-service/types';
import {isNullOrUndefined} from 'util';

export const getFactory = () => {
  return new ErrorMessageFactory();
};

interface WebAPIHttpErrorResponse {
  errors: any[];
  default_error: any;
}

/**
 * Resolve a title for a custom error message based on the provided error type key
 * @param {string} typeRef
 * @returns {string}
 */
const errorLabelByType = (typeRef: string) => {
  let label = webapiErrorToLabel.get(typeRef);

  if (!label) {
    label = typeRef;
  }

  return label;
};

class ErrorMessageFactory {
  constructor() {
  }

  forLegacyHttpResponse(response: any): ErrorMessage[] {
    return extractApiError(response.json());
  }
  forHttpResponse(response: HttpErrorResponse): ErrorMessage[] {
    return extractApiError(response.error);
  }
}

/**
 * The function tries to extract a message from a provided error stack.
 * This is used t get information about an error which is provided as a result at a failed request to the WebAPI
 *
 * @param responseAsJson
 * @returns {ErrorMessage}
 */
const extractApiError = (responseAsJson: WebAPIHttpErrorResponse): ErrorMessage[] => {
  const defaultTitle = 'An API Error occured';
  const defaultMessage = 'Take a look into the console to learn more';
  const errorMsg: ErrorMessage[] = [];
  const result = responseAsJson;
  const resultErrors = result.errors;
  const resultDefaultError = result.default_error;
  const hasDefaultError = !isNullOrUndefined(resultDefaultError);
  let hasErrors = !isNullOrUndefined(resultErrors);
  hasErrors = hasErrors && resultErrors instanceof Array;
  hasErrors = hasErrors && resultErrors.length > 0;

  if (hasErrors) {
    resultErrors.forEach((item: NormalizedApiError) => {
      let message = item.error_message;

      if (!isNullOrUndefined(item.hint) && !empty(item.hint)) {
        message = `${message} (${item.hint})`;
      }

      errorMsg.push(
        {title: errorLabelByType(item.error_type), message},
      );
    });
  } else if (hasDefaultError) {
    errorMsg.push({title: result['default_error'].title, message: result['default_error'].detail});
  } else {
    errorMsg.push({title: defaultTitle, message: defaultMessage});
  }

  return errorMsg;
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/utils/webapi-error-helper.ts